module.exports = __webpack_public_path__ + "static/media/chevron-right-blue.186613b0.svg";